
export default {
    sendHeaderEvent: function(eventName, detail){
        const elem = document.getElementById('header-links');
        if(elem){
            elem.dispatchEvent(new CustomEvent(eventName, {detail: detail}));
            //console.log('dispatched header event: ', event);
        }
    }
};
